import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { logNavigation } from '../utils/diagnosticLogger';
import './HeaderMenu.css';

// The header's menu button (next to the user button): tools that aren't main pages.
const ITEMS = [
  { path: '/wheels', label: 'Wheel Library', detail: 'Wheels, paint codes and photo search' },
  { path: '/inventory/powder', label: 'Powder Inventory', detail: 'Weigh, receive and reorder powder' },
];

const MenuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="4" y1="6" x2="20" y2="6" />
    <line x1="4" y1="12" x2="20" y2="12" />
    <line x1="4" y1="18" x2="20" y2="18" />
  </svg>
);

const HeaderMenu = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const onMenuPage = ITEMS.some((item) => location.pathname.startsWith(item.path));

  useEffect(() => {
    if (!open) return undefined;
    const onPointer = (event) => {
      if (ref.current && !ref.current.contains(event.target)) setOpen(false);
    };
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onPointer);
    document.addEventListener('touchstart', onPointer);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onPointer);
      document.removeEventListener('touchstart', onPointer);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const go = (path) => {
    setOpen(false);
    if (location.pathname === path) return;
    logNavigation(location.pathname, path, 'header-menu');
    navigate(path);
  };

  return (
    <div className="header-menu" ref={ref}>
      <button
        type="button"
        className={`header-menu-btn header-icon-btn ${onMenuPage ? 'active' : ''} ${open ? 'open' : ''}`}
        onClick={() => setOpen((value) => !value)}
        title="Menu"
        aria-label="Menu"
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <MenuIcon />
      </button>
      {open && (
        <div className="header-menu-dropdown" role="menu">
          {ITEMS.map((item) => (
            <button
              key={item.path}
              type="button"
              role="menuitem"
              className={`header-menu-item ${location.pathname.startsWith(item.path) ? 'active' : ''}`}
              onClick={() => go(item.path)}
            >
              <span className="header-menu-item-label">{item.label}</span>
              <span className="header-menu-item-detail">{item.detail}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default HeaderMenu;
